// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"fb17038d","793":"be035344"}[chunkId] + ".chunk.css";
};